import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to New Orleans or Houston needed",
      "Ideal for Fort Polk & JRTC soldiers on PCS and deployment orders",
      "Perfect for LSUA & Louisiana College study-abroad students",
      "Great for Rapides Regional Medical Center physicians on medical missions",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Rapides Parish post offices",
      "Good for planned international travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Rapides Parish facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest agency: New Orleans (~200 mi via I-49/US-71) or Houston (~200 mi via LA-28/I-49/I-10)",
      "NPIC appointment required before driving to either location",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to spend entire day traveling and waiting",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function AlexandriaLAProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Alexandria"
      headingExtra="LA"
      introText="Alexandria and Central Louisiana travelers — Fort Polk and JRTC soldiers on PCS and deployment orders, LSUA and Louisiana College study-abroad students, Rapides Regional Medical Center physicians on international medical missions, England Airpark business travelers, and Central Louisiana agriculture and forestry professionals — have several options for getting a passport fast. Here is how they compare, and why most Central Louisiana residents choose a U.S. Department of State registered passport courier rather than making the 200-mile drive to New Orleans or the 200-plus mile drive to Houston."
      options={options}
      emergencyDescription="Alexandria does not have a regional passport agency. The closest agencies are in New Orleans (roughly 200 miles via I-49 and US-71) and Houston (roughly 200 miles via LA-28, I-49, and I-10). You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at either agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Alexandria does not have a regional passport agency — the closest are New Orleans and Houston, both roughly 200 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}